export enum STEPS {
  SELECT_CUSTOMER = 1,
  ADD_NEW_CUSTOMER = 2,
  REVIEW_DETAILS = 3,
}
